import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeRolComponent } from './badge-rol.component';

@NgModule({
  declarations: [BadgeRolComponent],
  imports: [CommonModule],
  exports: [BadgeRolComponent]
})
export class BadgeRolModule { }
